import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import CompanyPromotion2 from "../PdfQuotationsTablesV2/company_promotion";
import ElectricFittings2 from "../PdfQuotationsTablesV2/electric_fittings";
import performRequest from "../../../api/request";
import { useParams } from "react-router-dom";
import CompanyDescription2 from "../PdfQuotationsTablesV2/company_description";
import NVPHSpecifications2 from "../PdfQuotationsTablesV2/nvph_specifications";
import FanPadSpecifications2 from "../PdfQuotationsTablesV2/fan_pad_specifications";
import AFrameSetup2 from "../PdfQuotationsTablesV2/a_frame_setup";
import FlatBedSetup2 from "../PdfQuotationsTablesV2/flat_bed_setup";
import GrowBagSetup2 from "../PdfQuotationsTablesV2/grow_bag_setup";
import DutchBucketSetup2 from "../PdfQuotationsTablesV2/dutch_bucket_setup";
import WaterStorageHandling2 from "../PdfQuotationsTablesV2/water_storage_and_handling";
import EmployeeTrainingProgramme2 from "../PdfQuotationsTablesV2/employee_training_programme";
import AgronomySupport2 from "../PdfQuotationsTablesV2/agronomy_support";
import ScopeOfWork2 from "../PdfQuotationsTablesV2/scope_of_work";
import CustomerResponsibility2 from "../PdfQuotationsTablesV2/customer_responsibility";
import CivilMaterials2 from "../PdfQuotationsTablesV2/civil_materials";
import SoftwareServices2 from "../PdfQuotationsTablesV2/software_services";
import MaterialBreakdown2 from "../PdfQuotationsTablesV2/material_breakdown";
import WorkOrderLocations2 from "../PdfQuotationsTablesV2/work_order_locations";
import WarrantyOnMaterial2 from "../PdfQuotationsTablesV2/warranty_on_material";
import TrackingOfProgress2 from "../PdfQuotationsTablesV2/tracking_of_progress";
import NetHouseSpecifications2 from "../PdfQuotationsTablesV2/net_house_specifications";
import PaymentDetails2 from "../PdfQuotationsTablesV2/payment_details";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Toast } from "../../../CustomComponent/toast";
import KryzenTop2 from "../PdfQuotationsTablesV2/kryzen_Top";
import ProjectFinancials2 from "../PdfQuotationsTablesV2/project_financials";
import QuotationAmounts2 from "../PdfQuotationsTablesV2/quotation_amounts";
import PaymentBreakdown2 from "../PdfQuotationsTablesV2/payment_breakdown";
import ProduceBreakevenTable2 from "../PdfQuotationsTablesV2/produce_breakeven_table";
import UserDetails2 from "../PdfQuotationsTablesV2/user_details";
import MaterialBreakdownCEA2 from "../PdfQuotationsTablesV2/material_breakdown_CEA";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcSurvey } from "react-icons/fc";
import CEACompo from "../../../certificates/CEACompo.jpg";
import CSofHydroponics from "../../../certificates/CSofHydroponics.jpg";
import Camparison2 from "../PdfQuotationsTablesV2/camparison";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

import CompanyPromotion from "../PdfQuotationsTables/company_promotion";
import ElectricFittings from "../PdfQuotationsTables/electric_fittings";
import CompanyDescription from "../PdfQuotationsTables/company_description";
import NVPHSpecifications from "../PdfQuotationsTables/nvph_specifications";
import FanPadSpecifications from "../PdfQuotationsTables/fan_pad_specifications";
import AFrameSetup from "../PdfQuotationsTables/a_frame_setup";
import FlatBedSetup from "../PdfQuotationsTables/flat_bed_setup";
import GrowBagSetup from "../PdfQuotationsTables/grow_bag_setup";
import DutchBucketSetup from "../PdfQuotationsTables/dutch_bucket_setup";
import WaterStorageHandling from "../PdfQuotationsTables/water_storage_and_handling";
import EmployeeTrainingProgramme from "../PdfQuotationsTables/employee_training_programme";
import AgronomySupport from "../PdfQuotationsTables/agronomy_support";
import ScopeOfWork from "../PdfQuotationsTables/scope_of_work";
import CustomerResponsibility from "../PdfQuotationsTables/customer_responsibility";
import CivilMaterials from "../PdfQuotationsTables/civil_materials";
import SoftwareServices from "../PdfQuotationsTables/software_services";
import MaterialBreakdown from "../PdfQuotationsTables/material_breakdown";
import WorkOrderLocations from "../PdfQuotationsTables/work_order_locations";
import WarrantyOnMaterial from "../PdfQuotationsTables/warranty_on_material";
import TrackingOfProgress from "../PdfQuotationsTables/tracking_of_progress";
import NetHouseSpecifications from "../PdfQuotationsTables/net_house_specifications";
import PaymentDetails from "../PdfQuotationsTables/payment_details";
import KryzenTop from "../PdfQuotationsTables/kryzen_Top";
import ProjectFinancials from "../PdfQuotationsTables/project_financials";
import QuotationAmounts from "../PdfQuotationsTables/quotation_amounts";
import PaymentBreakdown from "../PdfQuotationsTables/payment_breakdown";
import ProduceBreakevenTable from "../PdfQuotationsTables/produce_breakeven_table";
import UserDetails from "../PdfQuotationsTables/user_details";
import MaterialBreakdownCEA from "../PdfQuotationsTables/material_breakdown_CEA";
import Soilbased_precision_farming from "../PdfQuotationsTables/soilbased_precision_farming";
const PublicQuotation = () => {
  const { emailEncoded } = useParams();
  const [quot, setQuot] = useState();
  //   const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [allQData, setAllQData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  let id = "";
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotations/getPublicQuotaion/${emailEncoded}`)
      .then((res) => {
        if (res.status === 200) {
          setdata(res.data?.input_info);
          id = res.data?.quotationNumber.split("/").pop();
          setQuot(res.data?.quotationNumber);
          setAllQData(res.data);
        } else {
          Toast("error", "Error while getting Quotations!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, emailEncoded]);
  const [sendingWhatspp, setSendingWhatspp] = useState(false);

  function QuotationNumber() {
    return id.toString().padStart(4, "0");
  }
  function GetArea() {
    let area = data?.bay_size * data?.span_size;
    return area;
  }

  function joinWithDash(inputString) {
    var wordsArray = inputString.split(" ");
    var joinedString = wordsArray.join("-");
    return joinedString;
  }
  const printPDF = () => {
    let name = joinWithDash(
      `${QuotationNumber()}-${GetArea()}SqM-${
        data?.businessName || data?.contactPersonName
      }-${getQuotationFor(allQData?.input_info)}.pdf`
    );
    document.title = name;
    window.print();
  };

  //   function generatePDF() {
  //     setLoading(true);
  //     performRequest("PATCH", `/quotations/updateQuotations/${id}`, {
  //       pdfStatus: true,
  //     })
  //       .then((res) => {
  //         if (res.status === 200) {
  //           setRefresh(!refresh);
  //           Toast("success", "PDF generated successfully!");
  //         } else {
  //           Toast("error", "Error while generating PDF!");
  //         }
  //       })
  //       .catch((err) => {
  //         CustomErrorResponse(err);
  //       })
  //       .finally(() => setLoading(false));
  //   }

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2  me-1" /> Quotation
                </h2>
                <h4 className="text-muted">
                  Quotation for {data?.businessName || data?.contactPersonName}
                </h4>
              </div>
              {allQData?.input_info && (
                <div className="col-md-4">
                  <div className="btn-list justify-content-end">
                    {/* <WhatsAppButton
                      buttonText={sendingWhatspp ? "SENDING..." : "SEND QUOTE"}
                      disabled={sendingWhatspp ? true : false}
                      svg={
                        sendingWhatspp ? (
                          <div
                            class="spinner-border me-2 fs-1 spinner-border-sm text-white"
                            role="status"
                          ></div>
                        ) : (
                          ""
                        )
                      }
                      onClick={handleGenerateAndSendWhatsAppPDF}
                    /> */}
                    <SimpleButton buttonText={"save pdf"} onClick={printPDF} />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="card">
            {quot?.includes("A/V2") ? (
              <div className="card-body" id="pdf-content">
                {data &&
                  (data?.quotationType === "fanpad" ||
                    data?.quotationType === "nethouse" ||
                    data?.quotationType === "nvph" ||
                    data?.quotationType === "soilbasedfanpad" ||
                    data?.quotationType === "soilbasednvph" ||
                    data?.quotationType === "soilbasednethouse") && (
                    <>
                      <KryzenTop2 />
                      {data && (
                        <CompanyDescription2
                          allQData={allQData}
                          businessName={
                            data?.businessName || data?.contactPersonName
                          }
                          address={data?.address}
                          data={data}
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data && (
                        <UserDetails2
                          userInfo={data}
                          area={allQData?.area_in}
                        />
                      )}
                      {data && data?.quotationType === "fanpad" && (
                        <FanPadSpecifications2 />
                      )}

                      {data && data?.quotationType === "nethouse" && (
                        <NetHouseSpecifications2 />
                      )}

                      {data && data?.quotationType === "nvph" && (
                        <NVPHSpecifications2 />
                      )}

                      {
                        <div>
                          <div>
                            <img src={CEACompo} alt="CEACompo" />
                          </div>
                          <div
                            className="html2pdf__page-break"
                            style={{
                              pageBreakAfter: "always",
                              display: "block",
                              clear: "both",
                            }}
                          ></div>
                        </div>
                      }

                      {data && data?.foggerSystem && (
                        <WaterStorageHandling2
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data &&
                        data?.quotationType !== "nvph" &&
                        data?.quotationType !== "nethouse" && (
                          <ElectricFittings2 data={data} />
                        )}

                      {data && (
                        <TrackingOfProgress2
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data && (
                        <ScopeOfWork2 quotationType={data?.quotationType} />
                      )}
                      {data && (
                        <CustomerResponsibility2
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data && (
                        <CivilMaterials2 quotationType={data?.quotationType} />
                      )}
                      {/* working panding */}
                      {/* <AfterSalesServices_AMC /> */}

                      {
                        <MaterialBreakdownCEA2
                          quotationType={data?.quotationType}
                          data
                        />
                      }
                      {data && (
                        <WorkOrderLocations2
                          quotationType={data?.quotationType}
                        />
                      )}
                      <WarrantyOnMaterial2
                        quotationType={data?.quotationType}
                        data
                      />
                      <CompanyPromotion2 />
                      {data && data?.showProjectFinancials && (
                        <>
                          {data && data?.showProjectFinancials && allQData && (
                            <ProjectFinancials2
                              allQData={allQData}
                              quotationType={data?.quotationType}
                            />
                          )}
                          {allQData &&
                            allQData?.plant_grow?.updatedPlantsList && (
                              <ProduceBreakevenTable2 allQData={allQData} />
                            )}
                          <div
                            className="html2pdf__page-break"
                            style={{
                              pageBreakAfter: "always",
                              display: "block",
                              clear: "both",
                            }}
                          ></div>
                        </>
                      )}

                      <KryzenTop2 />
                      {allQData && (
                        <QuotationAmounts2
                          allQData={allQData}
                          quotationType={data?.quotationType}
                        />
                      )}
                      {allQData && <PaymentBreakdown2 allQData={allQData} />}
                      {data && <PaymentDetails2 data={data} />}
                    </>
                  )}
                {data &&
                  data?.quotationType !== "fanpad" &&
                  data?.quotationType !== "nethouse" &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "soilbasedfanpad" &&
                  data?.quotationType !== "soilbasednvph" &&
                  data?.quotationType !== "soilbasednethouse" && (
                    <>
                      <KryzenTop2 />
                      {data && (
                        <CompanyDescription2
                          allQData={allQData}
                          businessName={
                            data?.businessName || data?.contactPersonName
                          }
                          address={data?.address}
                          data={data}
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data && (
                        <UserDetails2
                          userInfo={data}
                          area={allQData?.area_in}
                        />
                      )}

                      {data &&
                        data?.quotationType === "fanpad with hydroponics" && (
                          <FanPadSpecifications2 />
                        )}

                      {data &&
                        data?.quotationType === "nethouse with hydroponics" && (
                          <NetHouseSpecifications2 />
                        )}

                      {data &&
                        data?.quotationType === "nvph with hydroponics" && (
                          <NVPHSpecifications2 />
                        )}
                      {data?.quotationType !== "hydroponics only" && (
                        <div>
                          <div>
                            <img src={CEACompo} alt="CEACompo" />
                          </div>
                          <div
                            className="html2pdf__page-break"
                            style={{
                              pageBreakAfter: "always",
                              display: "block",
                              clear: "both",
                            }}
                          ></div>
                        </div>
                      )}
                      {
                        <div>
                          <div>
                            <img src={CSofHydroponics} alt="hydroCompo" />
                          </div>
                          <div
                            className="html2pdf__page-break"
                            style={{
                              pageBreakAfter: "always",
                              display: "block",
                              clear: "both",
                            }}
                          ></div>
                        </div>
                      }

                      {
                        <>
                          {data && data?.flatBedPercent > 0 && (
                            <FlatBedSetup2 />
                          )}
                          {data && data?.a_FramePercent > 0 && <AFrameSetup2 />}
                          {data && data?.growBagPercent > 0 && (
                            <GrowBagSetup2 />
                          )}
                          {data && data?.dutchBucketPercent > 0 && (
                            <DutchBucketSetup2 />
                          )}
                        </>
                      }

                      {data && (
                        <WaterStorageHandling2
                          quotationType={data?.quotationType}
                          data={data}
                        />
                      )}
                      {data && <ElectricFittings2 data={data} />}
                      {
                        <>
                          <EmployeeTrainingProgramme2 />
                          <AgronomySupport2 />
                        </>
                      }
                      <TrackingOfProgress2 />
                      {data && (
                        <ScopeOfWork2
                          quotationType={data?.quotationType}
                          a_FramePercent={data?.a_FramePercent}
                          flatBedPercent={data?.flatBedPercent}
                          growBagPercent={data?.growBagPercent}
                          dutchBucketPercent={data?.dutchBucketPercent}
                        />
                      )}
                      {data && (
                        <CustomerResponsibility2
                          quotationType={data?.quotationType}
                        />
                      )}
                      <CivilMaterials2
                        quotationType={data?.quotationType}
                        a_FramePercent={data?.a_FramePercent}
                        flatBedPercent={data?.flatBedPercent}
                        growBagPercent={data?.growBagPercent}
                        dutchBucketPercent={data?.dutchBucketPercent}
                      />
                      {/* working panding */}
                      {/* <AfterSalesServices_AMC /> */}
                      {<SoftwareServices2 />}
                      {data && data?.quotationType !== "hydroponics only" && (
                        <MaterialBreakdown2
                          quotationType={data?.quotationType}
                        />
                      )}
                      {data && (
                        <WorkOrderLocations2
                          quotationType={data?.quotationType}
                          a_FramePercent={data?.a_FramePercent}
                          flatBedPercent={data?.flatBedPercent}
                          growBagPercent={data?.growBagPercent}
                          dutchBucketPercent={data?.dutchBucketPercent}
                          allQData={allQData}
                        />
                      )}
                      <Camparison2 />
                      {data && (
                        <WarrantyOnMaterial2
                          data
                          quotationType={data?.quotationType}
                        />
                      )}
                      <CompanyPromotion2 />
                      {data && data?.showProjectFinancials && (
                        <>
                          {data && data?.showProjectFinancials && allQData && (
                            <ProjectFinancials2
                              allQData={allQData}
                              quotationType={data?.quotationType}
                            />
                          )}
                          {allQData &&
                            allQData?.plant_grow?.updatedPlantsList && (
                              <ProduceBreakevenTable2 allQData={allQData} />
                            )}
                          <div
                            className="html2pdf__page-break"
                            style={{
                              pageBreakAfter: "always",
                              display: "block",
                              clear: "both",
                            }}
                          ></div>
                        </>
                      )}
                      <KryzenTop2 />
                      {allQData && (
                        <QuotationAmounts2
                          allQData={allQData}
                          quotationType={data?.quotationType}
                        />
                      )}
                      {allQData && <PaymentBreakdown2 allQData={allQData} />}
                      {data && <PaymentDetails2 data={data} />}
                    </>
                  )}
              </div>
            ) : (
              <div className="card-body" id="pdf-content">
                <KryzenTop />
                {data && (
                  <CompanyDescription
                    allQData={allQData}
                    businessName={data?.businessName || data?.contactPersonName}
                    address={data?.address}
                    data={data}
                    quotationType={data?.quotationType}
                  />
                )}
                {data && (
                  <UserDetails userInfo={data} area={allQData?.area_in} />
                )}
                {data &&
                  (data?.quotationType === "fanpad" ||
                    data?.quotationType === "soilbasedfanpad") && (
                    <FanPadSpecifications quotationType={data?.quotationType} />
                  )}

                {data && data?.quotationType === "fanpad with hydroponics" && (
                  <FanPadSpecifications quotationType={data?.quotationType} />
                )}
                {data &&
                  (data?.quotationType === "nethouse" ||
                    data?.quotationType === "soilbasednethouse") && (
                    <NetHouseSpecifications data={data} />
                  )}
                {data &&
                  data?.quotationType === "nethouse with hydroponics" && (
                    <NetHouseSpecifications data={data} />
                  )}
                {data &&
                  (data?.quotationType === "nvph" ||
                    data?.quotationType === "soilbasednvph") && (
                    <NVPHSpecifications />
                  )}
                {data && data?.quotationType === "nvph with hydroponics" && (
                  <NVPHSpecifications />
                )}
                {(data?.quotationType === "soilbasedfanpad" ||
                  data?.quotationType === "soilbasednvph" ||
                  data?.quotationType === "soilbasednethouse") && (
                  <Soilbased_precision_farming />
                )}
                {/* percent wise setup */}
                {data?.quotationType !== "fanpad" &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "nethouse" &&
                  data?.quotationType !== "soilbasedfanpad" &&
                  data?.quotationType !== "soilbasednvph" &&
                  data?.quotationType !== "soilbasednethouse" && (
                    <>
                      {data && data?.flatBedPercent > 0 && <FlatBedSetup />}
                      {data && data?.a_FramePercent > 0 && <AFrameSetup />}
                      {data && data?.growBagPercent > 0 && <GrowBagSetup />}
                      {data && data?.dutchBucketPercent > 0 && (
                        <DutchBucketSetup />
                      )}
                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </>
                  )}

                {data &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "soilbasednvph" && (
                    <WaterStorageHandling
                      quotationType={data?.quotationType}
                      data={data}
                    />
                  )}

                {data &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "soilbasednvph" && (
                    <ElectricFittings
                      data={data}
                      quotationType={data?.quotationType}
                    />
                  )}
                {data?.quotationType !== "fanpad" &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "nethouse" &&
                  data?.quotationType !== "soilbasedfanpad" &&
                  data?.quotationType !== "soilbasednvph" &&
                  data?.quotationType !== "soilbasednethouse" && (
                    <>
                      <EmployeeTrainingProgramme />
                      <AgronomySupport />
                    </>
                  )}
                <TrackingOfProgress />

                {data && <ScopeOfWork quotationType={data?.quotationType} />}
                <CustomerResponsibility quotationType={data?.quotationType} />
                <CivilMaterials quotationType={data?.quotationType} />
                {/* working panding */}
                {/* <AfterSalesServices_AMC /> */}
                {data?.quotationType !== "fanpad" &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "nethouse" &&
                  data?.quotationType !== "soilbasedfanpad" &&
                  data?.quotationType !== "soilbasednvph" &&
                  data?.quotationType !== "soilbasednethouse" && (
                    <SoftwareServices />
                  )}
                {data &&
                  data?.quotationType !== "hydroponics only" &&
                  data?.quotationType !== "fanpad" &&
                  data?.quotationType !== "nvph" &&
                  data?.quotationType !== "nethouse" &&
                  data?.quotationType !== "soilbasedfanpad" &&
                  data?.quotationType !== "soilbasednvph" &&
                  data?.quotationType !== "soilbasednethouse" && (
                    <MaterialBreakdown />
                  )}
                {(data?.quotationType === "fanpad" ||
                  data?.quotationType === "nvph" ||
                  data?.quotationType === "nethouse" ||
                  data?.quotationType === "soilbasedfanpad" ||
                  data?.quotationType === "soilbasednvph" ||
                  data?.quotationType === "soilbasednethouse") && (
                  <MaterialBreakdownCEA quotationType={data?.quotationType} />
                )}
                {data && (
                  <WorkOrderLocations quotationType={data?.quotationType} />
                )}
                <WarrantyOnMaterial quotationType={data?.quotationType} />
                <CompanyPromotion />
                {data && data?.showProjectFinancials && (
                  <>
                    {data && data?.showProjectFinancials && allQData && (
                      <ProjectFinancials
                        allQData={allQData}
                        quotationType={data?.quotationType}
                      />
                    )}
                    {allQData && allQData?.plant_grow?.updatedPlantsList && (
                      <ProduceBreakevenTable allQData={allQData} />
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        objectFit: "contain",
                        marginTop: "12px",
                      }}
                    >
                      <img
                        src={
                          "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079851/whyWeChooseKBPL_nwyh7d_xliuvq_jj8uap.png"
                        }
                        width={"80%"}
                        alt="kryzenCertificates"
                      />
                    </div>

                    <div
                      className="html2pdf__page-break"
                      style={{
                        pageBreakAfter: "always",
                        display: "block",
                        clear: "both",
                      }}
                    ></div>
                  </>
                )}

                <KryzenTop />
                {allQData && (
                  <QuotationAmounts
                    allQData={allQData}
                    quotationType={data?.quotationType}
                  />
                )}
                {allQData && <PaymentBreakdown allQData={allQData} />}
                {data && <PaymentDetails data={data} />}
              </div>
            )}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PublicQuotation;
